const data = {
  region: "北培",
  shop: "北培",
  Today: {
    a: 0.0193461, // 整体销售
    b: 1841, // 非素业绩
    c: -0.984743, // 非素业绩同比
    d: 9980, // 素1业绩
  },
  MTD: {
    a: 0.0193461, // 整体销售
    b: 1841, // 非素业绩
  },
  YTD: {
    a: 0.0193461, // 整体销售
    b: 1841, // 非素业绩
  },
};

const data2 = [
  {
    KPI: "整体销售",
    Today: 123,
    MTD: 123,
  },
];

export function getData(KPI) {
  return data2.find((v) => v.KPI === KPI);
}

const data3 = [
  {
    KPI: "整体销售",
    Today: 123,
    MTD: 123,
    YTD: 456,
  },
];

const obj = {
  整体销售: "a",
  转换业绩: "b",
};

export function formatData() {
  const info = {
    Today: {},
    MTD: {},
    YTD: {},
  };
  data3.forEach((v) => {
    let key = obj[v.KPI];
    info.Today[key] = v.Today;
    info.MTD[key] = v.MTD;
    info.YTD[key] = v.YTD;
  });

  return info;
}
console.log(formatData());
